import { render, staticRenderFns } from "./documents-form.vue?vue&type=template&id=08ef0027&scoped=true"
import script from "./documents-form.vue?vue&type=script&lang=js"
export * from "./documents-form.vue?vue&type=script&lang=js"
import style0 from "./documents-form.vue?vue&type=style&index=0&id=08ef0027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef0027",
  null
  
)

export default component.exports